import "./Companies.module.css";
import Header from "@/reusable_sections/Header";
import Enterprise from "./sections/Enterprise";
import Gasolineras from "./sections/Gasolineras";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function CompaniesPage() {
  return <div>
      <Header />
      <Enterprise />
      <Gasolineras />
      <Action />
      <Footer />
    </div>;
}